import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UntypedFormArray, UntypedFormControl} from '@angular/forms';
import {MatChipInputEvent} from '@angular/material/chips';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {NgxSpinnerService} from 'ngx-spinner';

import {EMPTY} from 'rxjs';

import {BaseFormComponent, FormManagerService} from '@sim/form';
import {Media} from '@sim/media';

import {CardType, SourceArcApiService} from '@atmi/core';
import {SourceArchivial, SourceArchivialMeta} from '@atmi/core/models';
import {Status} from '@atmi/core/models/status';
import {separatorKeysCodes} from '@atmi/core/utils';

@Component({
  selector: 'app-source-archivial-manager',
  styleUrls: ['./source-archivial-manager.component.scss'],
  templateUrl: './source-archivial-manager.component.html',
})
export class SourceArchivialManagerComponent extends BaseFormComponent<SourceArchivial> {

  readonly separatorKeysCodes = separatorKeysCodes;


  constructor(
    private readonly sourceArcApi: SourceArcApiService,
    protected readonly formManager: FormManagerService,
    protected readonly route: ActivatedRoute,
    protected readonly router: Router,
    protected readonly snackBarService: MatSnackBar,
    protected readonly spinner: NgxSpinnerService,
    protected readonly translate: TranslateService,
  ) {
    super(
      snackBarService,
      translate,
      route,
      formManager,
      spinner,
      undefined,
      SourceArchivialMeta,
      (id) => sourceArcApi.get(id as string),
      '/archival-sources',
      router,
    );
  }

  addConcrete(sourceArc: SourceArchivial) {
    return this.sourceArcApi.post(sourceArc);
  }


  removeConcrete(sourceArc: SourceArchivial) {
    if (sourceArc.id) {
      return this.sourceArcApi.remove(sourceArc.id);
    }
    return EMPTY;
  }

  editConcrete(sourceArc: SourceArchivial) {
    return this.sourceArcApi.put(sourceArc);
  }

  resetFormConcrete() {
    return EMPTY;
  }

  updateImageHandler(media: Media | undefined) {
    if (!this.entityControls) {
      throw new Error('Cannot set image');
    }

    if (!this.entityControls.immagine) {
      throw new Error('Cannot set image without a valid control');
    }

    if (media) {
      this.entityControls.immagine.setValue(media.id);
    } else {
      this.entityControls.immagine.setValue(undefined);
    }
  }

  updateFileHandler(media: Media | undefined) {
    if (!this.entityControls) {
      throw new Error('Cannot set file');
    }

    if (!this.entityControls.file) {
      throw new Error('Cannot set file without a valid control');
    }

    if (media) {
      this.entityControls.file.setValue(media.id);
    } else {
      this.entityControls.file.setValue(undefined);
    }
  }

  changeStatusHandler(status: Status) {
    if (!this.entityControls) {
      throw new Error('Cannot set status without a valid controls');
    }
    if (!this.entityControls.status) {
      throw new Error('Cannot set status without a valid control');
    }
    this.entityControls.status.setValue(status);
    this.entityControls.status.updateValueAndValidity();
  }

  removeTagHandler(tagForm: UntypedFormArray, index: number) {
    if (!tagForm.controls) {
      throw new Error('Cannot manage input without a control');
    }

    tagForm.removeAt(index);
  }

  addTagHandler(tagForm: UntypedFormArray, event: MatChipInputEvent, inputTag: HTMLInputElement): void {
    const value = (event.value || '').trim();
    if (!value) {
      return;
    }
    const control = new UntypedFormControl(value);

    tagForm.push(control);

    inputTag.value = '';
  }

}
